import UnicornApp from '../app';
import UnicornHelper from './helper';
import UnicornLoader from './loader';
export default class UnicornValidation {
    app;
    static install(app) {
        const $validation = app.$validation = new this(app);
        app.formValidation = async (selector = '[uni-form-validation]') => {
            await $validation.import();
            return $validation.get(selector);
        };
    }
    constructor(app) {
        this.app = app;
        //
    }
    /**
     * Import
     * @returns Promise<any>
     */
    async import() {
        const m = await this.$loader.import('@unicorn/ui/validation-components.js');
        // @ts-ignore
        window.UnicornValidation.initValidations(this.app);
        return m;
    }
    get $loader() {
        return this.app.inject('$loader');
    }
    get $helper() {
        return this.app.inject('$helper');
    }
    get(selector) {
        return this.$helper.getBoundedInstance(selector, 'form.validation');
    }
    getField(selector) {
        return this.$helper.getBoundedInstance(selector, 'field.validation');
    }
    async addGlobalValidator(name, validator, options = {}) {
        let m = await this.import();
        m.UnicornFormValidation.addGlobalValidator(name, validator, options);
        return m;
    }
}
